// extracted by mini-css-extract-plugin
export default {"Spinner":"Spinner_Spinner__+Z-E2","load1":"Spinner_load1__H-36e","SpinnerWrapper":"Spinner_SpinnerWrapper__misL1"};